import { AuthProviderIdentifier } from "../AuthProviderIdentifier.js";

export enum LoginErrorCodes {

    UNSPECIFIED_ERROR = 0,
    LOGIN_CANCELED = 2,
    NO_SESSION_FOUND = 101,
    WAITING_USER_ACTION = 3

}


export class LoginError {
    
    
    constructor (public readonly code: LoginErrorCodes,
                 public readonly message?: string,
                 public readonly data?: any
    ) { }

}

interface LoginCommonDataInterface {
    providerId: AuthProviderIdentifier,
    access_token?: string,
    id_token?: string,
    userId?: string,
    auth_code?: string
}


class LoginCommonData implements LoginCommonDataInterface {

    constructor(
        public readonly providerId: AuthProviderIdentifier,
        public readonly access_token?: string,
        public readonly id_token?: string,
        public readonly userId?: string,
        public readonly auth_code?: string
    ) {
        if(!access_token && !id_token && !auth_code) throw new Error("Missing idtoken a/o access token a/o auth_code");
    }

    public static FromInterface(i: LoginCommonDataInterface): LoginCommonData {
        return new LoginCommonData(i.providerId, i.access_token, i.id_token, i.userId, i.auth_code);
    }
}

export class ActualDataTuple extends LoginCommonData {}
export class IntermediateDataTuple extends LoginCommonData {}


export interface DeviceInfoForLogin {
    deviceId: string,
    deviceName: string
}


export interface ThirdPartyCientAuthDataInterface {
    intermediateData: LoginCommonDataInterface;
    actualData: LoginCommonDataInterface;
    signInParameters?: any;
    deviceInfo?: DeviceInfoForLogin
}

export class ThirdPartyCientAuthData implements ThirdPartyCientAuthDataInterface {

    constructor(
        public readonly intermediateData: IntermediateDataTuple|null,
        public readonly actualData: ActualDataTuple,
        public signInParameters?: any,
        public deviceInfo?: DeviceInfoForLogin
    ) {}

    public static FromInterface(i: ThirdPartyCientAuthDataInterface): ThirdPartyCientAuthData {
        return new ThirdPartyCientAuthData(
            i.intermediateData == null ? null : LoginCommonData.FromInterface(i.intermediateData),
            LoginCommonData.FromInterface(i.actualData),
            i.signInParameters,
            i.deviceInfo
        );
    }
}



export class ThirdParyClientAuthDataForSignIn extends ThirdPartyCientAuthData {

    constructor(
        tpd: ThirdPartyCientAuthData,
        public readonly loginOriginUrl?: string
    ) {
        super(tpd.intermediateData, tpd.actualData, tpd.signInParameters, tpd.deviceInfo);
    }
}